import * as React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Breadcrumbs, { breadcrumbsClasses } from "@mui/material/Breadcrumbs";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme || theme).palette.action.disabled,
    margin: 3,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: "center",
  },
}));

export default function NavbarBreadcrumbs() {
  let navPath = "";
  const theme = useTheme();
  const location = useLocation();
  const { pathname } = location;
  const segment = pathname.split("/");
  const segment_str = segment[1];
  if (segment_str) {
    navPath = segment_str[0].toUpperCase() + segment_str.slice(1);
  }

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={
        <NavigateNextRoundedIcon
          fontSize="large"
          sx={{ color: theme.palette.text.primary }}
        />
      }
    >
      <Typography variant="h4" sx={{ color: theme.palette.text.primary }}>
        medical<strong>WISDOM</strong>
      </Typography>
      <Typography
        variant="h4"
        sx={{ color: theme.palette.text.primary, fontWeight: "bold" }}
      >
        {navPath}
      </Typography>
    </StyledBreadcrumbs>
  );
}
